import { BottomSheet } from 'react-spring-bottom-sheet';
import 'react-spring-bottom-sheet/dist/style.css';
import {MobileSize} from "@/components/responsive";

export default function MobileBottomSheet({open, children, otherClassName="", ...otherProps}) {
    return (
        <MobileSize>
            <BottomSheet
                open={open}
                scrollLocking
                className={`pol-bottom-sheet ${otherClassName}`}
                {...otherProps}>
                {children}
            </BottomSheet>
        </MobileSize>
    )
}
